import entranceSlides from "./entrance";
import mainSlides from "./main";
import finalSlides from "./final";

const schemas = [...entranceSlides, ...mainSlides, ...finalSlides];

export default schemas;
